import React, { useState } from 'react';
import { Send, Loader2, X } from 'lucide-react';
import { api } from '../../context/AuthContext';

// Ein Klick: PDF als Kopie in den Mandanten-Chat – mit kurzer Bestätigung und optionalem Begleittext
export const AnMandantSenden = ({ caseId, kind = 'portal', docId, filename, onGesendet, klein }) => {
  const [offen, setOffen] = useState(false);
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const senden = async () => {
    setBusy(true); setMsg('');
    try { await api.post(`/cases/${caseId}/documents/${kind}/${docId}/an-mandant`, { text }); setOffen(false); setText(''); setMsg('An Mandanten gesendet'); onGesendet?.(); }
    catch (x) { setMsg(x?.response?.data?.detail || 'Senden fehlgeschlagen'); }
    setBusy(false);
  };
  if (!offen) return (
    <span className="inline-flex items-center gap-2">
      <button type="button" onClick={() => setOffen(true)} title="Kopie in den Mandanten-Chat senden" className={klein ? 'w-8 h-8 flex items-center justify-center text-[#b8893d] hover:bg-[#fbf7f0] rounded-sm' : 'h-8 px-3.5 rounded-full border border-[#b8893d]/50 bg-white text-xs text-[#1B3A5C] hover:border-[#b8893d] inline-flex items-center gap-1.5'} data-testid={`an-mandant-${docId}`}>
        <Send className={klein ? 'w-4 h-4' : 'w-3.5 h-3.5'} />{!klein && 'An Mandanten senden'}
      </button>
      {msg && <span className={`text-[11px] ${msg.startsWith('An') ? 'text-emerald-700' : 'text-rose-700'}`} data-testid={`an-mandant-meldung-${docId}`}>{msg}</span>}
    </span>
  );
  return (
    <div className="basis-full mt-2 rounded-xl border border-[#b8893d]/40 bg-[#fbf7f0] p-3 space-y-2" data-testid={`an-mandant-dialog-${docId}`}>
      <p className="text-xs text-[#15202B]"><b>{filename}</b> als Kopie in den Mandanten-Chat dieser Akte senden?</p>
      <textarea value={text} onChange={(e) => setText(e.target.value)} rows={2} placeholder="Begleittext (optional), z. B. „Anbei unser Schreiben an die Gegenseite zur Kenntnis.“" className="w-full px-2.5 py-2 rounded-lg border border-gray-200 bg-white text-sm" data-testid={`an-mandant-text-${docId}`} />
      <div className="flex flex-wrap items-center gap-2">
        <button type="button" onClick={senden} disabled={busy} className="h-8 px-4 rounded-full bg-[#1B3A5C] text-white text-xs hover:bg-[#b8893d] inline-flex items-center gap-1.5 disabled:opacity-50" data-testid={`an-mandant-bestaetigen-${docId}`}>{busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Send className="w-3.5 h-3.5" />}Jetzt senden</button>
        <button type="button" onClick={() => setOffen(false)} className="h-8 px-3 text-xs text-[#7a8a99] inline-flex items-center gap-1" data-testid={`an-mandant-abbrechen-${docId}`}><X className="w-3.5 h-3.5" />Abbrechen</button>
        {msg && <span className="text-[11px] text-rose-700">{msg}</span>}
      </div>
    </div>
  );
};

export default AnMandantSenden;
